// src/components/molecules/delivery/index.js
export { default } from './Delivery.tsx';
